import React from 'react'
import CTAButton from './CTAButton'
import FAQItem from './FAQItem'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    faqSection: {
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#f0f1f3',
        '@media screen and (max-width: 768px)': {
            paddingTop: '60px',
            paddingBottom: '60px',
        },
        '@media screen and (max-width: 480px)': {
            paddingTop: '40px',
            paddingBottom: '40px',
        },
    },
    
    faqHeader: {
        textAlign: 'center',
        marginBottom: '40px',
        '@media screen and (max-width: 480px)': {
            marginBottom: '0px',
        },
    },
    
    faqContainer: {
        paddingBottom: '30px',
        maxWidth: '1000px',
        margin: 'auto',
        '@media screen and (max-width: 480px)': {
            paddingTop: '30px',
            paddingBottom: '40px',
        },
    }
    
})

function FAQ() {

    var classes = useStyles()

    const faqs = [
        {id: "1", question: "Who Is The NxG Entrepreneurship Bootcamp For?", answer: "The NxG EB track is for students and aspiring entrepreneurs who have the willingness to positively contribute to their society.It is for students looking to nurture their creative and entrepreneurial side while contributing to making the world a better place.With our innovative pedagogy, start thinking and behaving like an agent of change for yourself and others and create value for the society."},
        {id: "2", question: "What Journey Will I Go Through?", answer: "You will embark on a unique high-paced, challenging, and rewarding experience.The journey will consist of a series of interventions, assignments, activities and challenges, you'll be invited to solve by leveraging resources available in and around you and your peers.We've mapped out a timeline for you to have a very energetic experience over a 30 day period.If you pass and come out with an Idea and Business Model that is innovative and scalable, you'll join the final Battle where you would get a chance to pitch to an Expert Jury consisting of Investors, Incubators, Mentors, who will support you to launch your  startup and move from Zero to One."},
        {id: "3", question: "When Does The Program Start And What Are The Timings?", answer: "The program will start from 3rd June. Once you register, you will be added to a WhatsApp group where you will be updated regarding the other details."},
        {id: "4", question: "Can I Get A Refund?", answer: "We understand due to unforeseen circumstances you might not be able to attend the sessions of the program on scheduled date. With sincere apologies, we would like to inform you that we won't be able to provide you refund. However, we assure you that you can join our forthcoming program for free."},
        {id: "5", question: "I Still Didn't Understand About This Program, What Should I Do?", answer: "Please feel free to write your queries to us at <a href='mailto:info@nxg.co.in'>info@nxg.co.in</a> or call us on <a href='tel:+919328200570'>+91-93282-00570</a>."},
        {id: "6", question: "What Is The Mode Of This Program?", answer: "This program will be completely online with sessions conducted via Google Meet, Zoom, or similar virtual meeting tools"},
        {id: "7", question: "Will I Get A Certificate Of Completion?", answer: "Yes, you will receive a certificate of completion if you finish the entire program with the necessary conditions. The certificate will be given at the certification ceremony"}
        // {question: "", answer: ""},
    ]

    return (
        <div className={classes.faqSection}>
            <div className="container">
                <div className={classes.faqHeader}>
                    <h1>Frequently Asked Questions</h1>
                </div>
                <div className={classes.faqContainer}>

                    {
                        faqs.map((m) => (
                            <FAQItem id={m.id} question={m.question} content={m.answer} key={m.id}/>
                        ))
                    }

                </div>

                <CTAButton/>

            </div>
        </div>
    )
}

export default FAQ
